export default {
    base_url: {
        // "development": "http://192.168.0.106/review-server/public/index.php/review",
        "development": "http://www.res.com/index.php/review/",//tz
        // "development": "http://192.168.0.28/index.php/review/",//tz
        // "development": "http://api.scwyy.cn/review",
        "production": "https://api.scwyy.cn/review",//生产环境url
    },
    auth_key: "review-token",
}